import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce, noop, trim } from 'lodash';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import OutsideClickHandler from 'react-outside-click-handler';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';

import immutableToJS from 'helpers/immutableToJS';
import {
  DropdownItems,
  HighlightText,
  injectIntl,
} from 'components';
import TextField from '@material-ui/core/TextField';
import { getProducts, getProductSubnames } from 'redux/products/actions';
import { selectState } from 'redux/selectors';
import { removeEmojis } from 'helpers/utils';

const limit = 100;

export class AutoFill extends Component {

  static propTypes = {
    disabled: PropTypes.bool,
    inputFieldStyle: PropTypes.shape({}),
    primary: PropTypes.bool,
    productSubnames: PropTypes.arrayOf(
      PropTypes.shape({}),
    ).isRequired,
    productSubnamesRequesting: PropTypes.bool.isRequired,
    products: PropTypes.arrayOf(
      PropTypes.shape({}),
    ).isRequired,
    productsRequesting: PropTypes.bool.isRequired,
    name: PropTypes.string,
    subname: PropTypes.string,

    formatMessage: PropTypes.func.isRequired,
    getProductSubnames: PropTypes.func.isRequired,
    getProducts: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    inputFieldStyle: {},
    primary: false,
    name: '',
    subname: '',
    onSelect: noop,
  };

  state = {
    searchText: this.props.primary ? this.props.name : this.props.subname,
    showItems: false,
  };

  componentDidMount() {
    this._ismounted = true;
    this.setFocusInterval = setTimeout(() => { this.textRef.focus(); }, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.name !== this.props.name && nextProps.primary) {
      this.setState({ searchText: nextProps.name });
    }
    if (nextProps.subname !== this.props.subname && !nextProps.primary) {
      this.setState({ searchText: nextProps.subname });
    }
    if (nextProps.name !== this.props.name && !nextProps.primary) {
      nextProps.getProductSubnames({
        limit,
        name: nextProps.name,
        search: nextProps.subname,
        searchFields: 'subname',
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.setFocusInterval);
    this._ismounted = false;
  }

  onBlur = () => {
    setTimeout(() => {
      if (this._ismounted) {
        this.setState({ showItems: false });
      }
    }, 300);
  }

  onChangeSearchText = (text) => {
    const searchText = removeEmojis(text);
    this.setState({ searchText }, this.handleListAccounts);
    this.updateParentState(searchText);
    // this.setState({ showItems: true });
  }

  onClick = (item) => {
    const { onSelect } = this.props;

    this.setState({ showItems: false });
    onSelect(item);
  }

  onClickForTextField = () => {
    const { disabled } = this.props;
    if (disabled) return;
    this.setState({ showItems: true });
  }

  getOptions = () => {
    const { products, productSubnames, primary } = this.props;
    const { searchText, showItems } = this.state;

    if (!showItems) return [];

    if (primary) {
      const approvedProducts = products.filter(item => item.approved);
      return approvedProducts.map(item => ({
        id: item.id,
        primaryText: (
          <div className="products">
            <div className="item-name-subname">
              <div className="item-name">
                <HighlightText
                  highlight={searchText}
                  text={item.name}
                  color="#6699ff"
                />
              </div>
              <HighlightText
                highlight={searchText}
                text={item.subname}
                color="#6699ff"
              />
            </div>
            <div className="item-category">
              <HighlightText
                highlight={searchText}
                text={` : ${item.category}`}
                color="#6699ff"
              />
            </div>
          </div>
        ),
        onClick: () => this.onClick(item),
      }));
    }
    const approvedProductSubnames = productSubnames.filter(item => item.approved);
    const productsExtended = [
      { id: 0, subname: 'N/A', category: '' },
      ...approvedProductSubnames,
    ];
    return productsExtended.map(item => ({
      id: item.id,
      primaryText: (
        <div className="products">
          <div className="item-name-subname">
            <div>
              <HighlightText
                highlight={searchText}
                text={item.subname}
                color="#6699ff"
              />
            </div>
          </div>
          <div className="item-category">
            <HighlightText
              highlight={searchText}
              text={` : ${item.category}`}
              color="#6699ff"
            />
          </div>
        </div>
      ),
      onClick: () => this.onClick(item),
    }));
  }

  updateParentState = (text) => {
    const { primary, onSelect } = this.props;
    if (primary) {
      onSelect({ name: trim(text) });
    } else {
      onSelect({ subname: trim(text) });
    }
  }

  listProducts = () => {
    const { name, getProducts, getProductSubnames, primary, onSelect, products } = this.props;
    const { searchText: text } = this.state;
    if (primary) {
      if (!products.find(product => product.name === text)) {
        if (trim(text) !== name) {
          onSelect({ name: text, category: '' });
        } else {
          onSelect({ name: trim(text) });
        }
      }
      this.setState({ showItems: true });
    } else {
      if (trim(text) !== this.props.subname) {
        onSelect({ subname: text, category: '' });
      } else {
        onSelect({ subname: trim(text) });
      }
    }

    if (text.length < 3 && primary) return;

    if (primary) {
      getProducts({
        limit,
        search: text,
      });
    } else {
      getProductSubnames({
        limit,
        name,
        search: text,
        searchFields: 'subname',
      });
    }
  };

  handleListAccounts = debounce(this.listProducts, 300);

  render() {
    const {
      disabled,
      formatMessage,
      inputFieldStyle,
      primary,
      productsRequesting,
      productSubnamesRequesting,
    } = this.props;
    const { searchText, showItems } = this.state;

    const searchedItems = (
      <DropdownItems
        loading={primary ? productSubnamesRequesting : productsRequesting}
        options={this.getOptions()}
      />
    );

    return (
      <div className="search-store-items">
        <OutsideClickHandler onOutsideClick={this.onBlur}>
          <TextField
            autoComplete="off"
            disabled={disabled}
            fullWidth
            InputProps={{
              endAdornment: disabled ? null : (
                <InputAdornment position="end">
                  <Search style={{ color: 'grey' }} />
                </InputAdornment>
              ),
              style: inputFieldStyle,
              spellCheck: false,
              autoCorrect: 'off',
              autoComplete: 'off',
            }}
            label={primary ? formatMessage('Name *') : formatMessage('Subname *')}
            placeholder={primary ? formatMessage('Name *') : formatMessage('Subname *')}
            name="search"
            onChange={({ target: { value } }) => this.onChangeSearchText(value)}
            onClick={this.onClickForTextField}
            onFocus={this.onFocus}
            inputRef={(c) => {
              this.textRef = c;
            }}
            value={searchText}
            variant="outlined"
          />
          <div>{showItems && searchedItems}</div>
        </OutsideClickHandler>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('products', 'products')(state),
  ...selectState('products', 'productSubnames')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  getProducts: payload => dispatch(getProducts(payload)),
  getProductSubnames: payload => dispatch(getProductSubnames(payload)),
});

export default compose(
  setDisplayName('AutoFill'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
  injectIntl,
)(AutoFill);
